import {
  anEntityInterface,
  aSignalPage,
  mockInsightEntityDetailsQueryQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightEntityDetailsQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entity: {
            ...anEntityInterface(),
            signals: aSignalPage(),
          },
        },
      });
    }
  ),
];
